<template>
    <p class="bigTitle">
        {{title}}
    </p>
</template>
<script>
export default {
    props: ['title'],
    components: {
    },
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>